import React from "react";

const Projects = () => {
  return (
    <div className="h-screen p-3 pt-5  ">
      <div id="project" className="text-center ">
        <section className="text-4xl ">Projects</section>
      </div>
          <div className=" pt-4 pb-4  grid  justify-items-center gap-5 lg:grid lg:grid-cols-3 lg:gap-4 lg:px-56 ">
            <div>
              <a
                href="https://my-app1-q8x8.onrender.com"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="object-cover h-60 w-full sm:w-full cursor-pointer"
                  src={require("./Images/SmartBrainApp.png")}
                  alt=""
                />
              </a>
             
            </div>
            <div >
              <a
                href="https://advice-generator-by-dk.netlify.app"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="object-cover h-60 w-full cursor-pointer"
                  src={require("./Images/advicegenerator.png")}
                  alt=""
                />
              </a>
           
            </div>
            <div >
              <a
                href="https://nft-preview-card-componentdk.netlify.app/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="object-cover h-60 w-full cursor-pointer"
                  src={require("./Images/NFT.png")}
                  alt=""
                />
              </a>
             
            </div>
            <div >
              <a
                href="https://qr-in-frontendmentor.netlify.app/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="object-cover h-60 w-full cursor-pointer"
                  src={require("./Images/qr.png")}
                  alt=""
                />
              </a>
             
            </div>
            <div >
              <a
                href="https://newshomepagedk.netlify.app/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="object-cover h-60 w-full cursor-pointer"
                  src={require("./Images/home_page.jpg")}
                  alt=""
                />
              </a>
            </div>
            <div >
              <a
                href="https://landinpage-easybank.netlify.app/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="object-cover h-60 w-full cursor-pointer"
                  src={require("./Images/Easybanklandingpage.png")}
                  alt=""
                />
              </a>
            </div>
          </div>
      </div>
  );
};
export default Projects;
